import { container } from './Container'

export function useDependency<T>(key: symbol): T {
  return container.get(key)
}
